var _filter, _filter2, _filter3, _circle, _circle2, _circle3, _text, _g, _g2, _g3, _g4, _g5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogoCustomizable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#2563eb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#60a5fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.4
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "textGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 2
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 90,
    fill: "url(#bgGradient)",
    filter: "url(#shadow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 85,
    fill: "none",
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 75,
    fill: "none",
    stroke: "rgba(255,255,255,0.05)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 125,
    fontFamily: "'Arial Black', 'Arial Bold', Arial, sans-serif",
    fontSize: 80,
    fontWeight: 900,
    fill: "white",
    textAnchor: "middle",
    letterSpacing: -4,
    filter: "url(#textGlow)"
  }, "\n    VB\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 155,
    width: 80,
    height: 24,
    rx: 12,
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 156,
    width: 78,
    height: 22,
    rx: 11,
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 171,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "white",
    textAnchor: "middle"
  }, "\n      DevOps\n    "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(155, 45)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3.5,-10 L -3.5,-14 L 3.5,-14 L 3.5,-10 M -10,-3.5 L -14,-3.5 L -14,3.5 L -10,3.5 M -3.5,10 L -3.5,14 L 3.5,14 L 3.5,10 M 10,-3.5 L 14,-3.5 L 14,3.5 L 10,3.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "url(#bgGradient)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45, 155)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L -6,-10 L 0,-20",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,0 L 18,-10 L 12,-20",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45, 45)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 12,
    ry: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6,
    cy: 2,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 2,
    r: 5,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(155, 155)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#10b981"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.4;1",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "6;7;6",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60 90 Q 40 70, 60 50 Q 80 30, 100 50 Q 120 70, 140 50 Q 160 30, 140 70 Q 120 90, 100 70 Q 80 50, 60 70 Z",
    fill: "none",
    stroke: "rgba(255,255,255,0.15)",
    strokeWidth: 2,
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoCustomizable);
export default __webpack_public_path__ + "static/media/brand-logo-customizable.e27ffea92fbf295b07983247b0d91466.svg";
export { ForwardRef as ReactComponent };